import React from 'react';
import classNames from 'classnames';

import iconChat from '../../../../assets/images/icon_chat_bloco.svg';
import iconChatAtivo from '../../../../assets/images/Icon_chat_ativo.svg';
import iconeIntegracao from '../../../../assets/images/plugin_novidade.svg';
import iconIntegracaoAtivo from '../../../../assets/images/icon_plugin_ativo.svg';
import iconJira from '../../../../assets/images/jira_icon.png';
import iconRDStation from '../../../../assets/images/rd-station.jpeg';
import iconVtex from '../../../../assets/images/vTex_icon.png';
import iconZendesk from '../../../../assets/images/zendesk_icon.png';
import SubMenuJira from './subMenuJira';
import SubMenuRDStation from './SubMenuRDStation';
import iconGlpi from '../../../../assets/images/glpi_icon.png';

const SubMenuChatItems = ({
  handleDragStart,
  handleDragEnd,
  draggingType,
  isActive,
  isBlocos,
  clickTypeBlocos,
}) => {
  return (
    <div
      className={`menu-criador-submenu creator-menu-integracao submenu-blocos ${
        isActive ? '' : 'hidden'
      }`}
    >
      <div className="header-menu-criador-submenu-blocos">
        <div
          className={
            isBlocos === 'chat'
              ? 'container-header-menu-blocos '
              : 'container-header-menu-blocos select-bloco-background'
          }
          onClick={() => clickTypeBlocos('chat')}
        >
          <img src={isBlocos === 'chat' ? iconChatAtivo : iconChat} />
        </div>
        <div
          className={
            isBlocos === 'integracao'
              ? 'container-header-menu-blocos '
              : 'container-header-menu-blocos select-bloco-background'
          }
          onClick={() => clickTypeBlocos('integracao')}
        >
          <img
            src={
              isBlocos === 'integracao' ? iconIntegracaoAtivo : iconeIntegracao
            }
          />
        </div>
      </div>
      <ul
        className="creator-menu creator-menu-integracao"
        hidden={isBlocos !== 'chat'}
      >
        <li
          className="header"
          data-toggle="collapse"
          data-target="#creator-menu--blocos-padrao"
        >
          Blocos Padrões
        </li>

        <ul id="creator-menu--blocos-padrao">
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Text',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--texto"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--texto"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Text')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Text' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Texto"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_menu_texto.svg"
                alt=""
              />
              <p>Texto</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Menu',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--menu"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--menu"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Menu')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Menu' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Menu de Opções"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_menu_lista.svg"
                alt=""
              />
              <p>Menu</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Image',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--imagem"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--imagem"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Image')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Image' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Imagem"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_imagem.svg"
                alt=""
              />
              <p>Imagem</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Video',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--video"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--video"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Video')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Video' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Vídeo"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_video.svg"
                alt=""
              />
              <p>Vídeo</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Audio',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--audio"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--audio"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Audio')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Audio' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Texto"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_audio.svg"
                alt=""
              />
              <p>Áudio</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Document',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--documento"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--documento"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Document')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Document',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Documento"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_documento.svg"
                alt=""
              />
              <p>Documento</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Carousel',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--carousel"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--carousel"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Carousel')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Carousel',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Carousel"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_documento.svg"
                alt=""
              />
              <p>Carrossel</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Form',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--form"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--form"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Form')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Form',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Formulário"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_documento.svg"
                alt=""
              />
              <p>Formulário</p>
            </label>
          </li>
        </ul>

        <li
          className="header border-top"
          data-toggle="collapse"
          data-target="#creator-menu--avancado"
        >
          Blocos Avançados
        </li>

        <ul id="creator-menu--avancado">
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Collect',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--coleta"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--coleta"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Collect')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Collect',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Coleta"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_coleta.svg"
                alt=""
              />
              <p>Coleta</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'SMS',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--sms"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--sms"
              draggable
              onDragStart={(e) => handleDragStart(e, 'SMS')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'SMS' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="SMS"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_sms.svg"
                alt=""
              />
              <p>SMS</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'EMAIL',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--email"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--email"
              draggable
              onDragStart={(e) => handleDragStart(e, 'EMAIL')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'EMAIL' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Email"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_email.svg"
                alt=""
              />
              <p>Email</p>
            </label>
          </li>

          {/* <li>
                <span className={classNames({'d-none': draggingType !== 'Module', 'dragging-overlay': true})}></span>
                <input id="radio_avancado--modulo" type="radio" name="radio_blocos_padrao"/>
                <label htmlFor="radio_avancado--modulo" draggable onDragStart={(e) => handleDragStart(e, 'Module')} onDragEnd={(e) => handleDragEnd(e)} className={classNames({'dragging': draggingType === 'Module'})}>
                  <img src="/assets/images/icons/icon_hint.svg" className="hint" data-toggle="tooltip" data-placement="right" title="Módulo" alt=""/>
                  <img className="no-drag" src="/assets/images/icons/icon_modulo.svg" alt=""/><p>Módulo</p>
                </label>
              </li> */}

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'API',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--json"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--json"
              draggable
              onDragStart={(e) => handleDragStart(e, 'API')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'API' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="JSON API"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_json.svg"
                alt=""
              />
              <p>JSON API</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'APIV2',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--json-v2"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--json-v2"
              draggable
              onDragStart={(e) => handleDragStart(e, 'APIV2')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'APIV2' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="API V2"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_json.svg"
                alt=""
              />
              <p>API V2</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Script',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--script"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--script"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Script')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Script',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Script"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_script.svg"
                alt=""
              />
              <p>Script</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Human',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--humano"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--humano"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Human')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'Human' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Humano"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_humano.svg"
                alt=""
              />
              <p>Humano</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Conditional',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--condicional"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--condicional"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Conditional')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Conditional',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Conditional"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/icon_condicional.svg"
                alt=""
              />
              <p>Condicional</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'DynamicMedia',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--midia-dinamica"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--midia-dinamica"
              draggable
              onDragStart={(e) => handleDragStart(e, 'DynamicMedia')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'DynamicMedia',
              })}
              style={{ paddingRight: 0 }}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Mídia dinâmica"
                alt=""
              />
              <img
                className="no-drag"
                src={require('../../../../assets/images/icon_midia_dinamica.svg')}
                alt=""
              />
              <p>Mídia dinâmica</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Group',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--group"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--group"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Group')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Group',
              })}
              style={{ paddingRight: 0 }}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Grupo"
                alt=""
              />
              <div className="radio-icon-container">
                <img
                  className="no-drag radio-icon-container-img"
                  src={require('../../../../assets/images/icon_group_orange.svg')}
                  alt=""
                />
              </div>
              <p>Grupo</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'Redirect',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--redirect"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--redirect"
              draggable
              onDragStart={(e) => handleDragStart(e, 'Redirect')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'Redirect',
              })}
              style={{ paddingRight: 0 }}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Direcionador"
                alt=""
              />
              <div className="radio-icon-container">
                <img
                  className="no-drag radio-icon-container-img"
                  src={require('../../../../assets/images/icon_direcionador_orange.svg')}
                  alt=""
                />
              </div>
              <p>Direcionador</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'BotTransfer',
                'dragging-overlay': true,
              })}
              style={{ height: 100 }}
            />
            <input
              id="radio_avancado--bot-transfer"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--bot-transfer"
              draggable
              onDragStart={(e) => handleDragStart(e, 'BotTransfer')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'BotTransfer',
              })}
              style={{ paddingRight: 0 }}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Transf. Bot"
                alt=""
              />
              <div className="radio-icon-container" style={{ marginTop: 15 }}>
                <img
                  className="no-drag radio-icon-container-img"
                  style={{ width: 23, height: 23 }}
                  src={require('../../../../assets/images/icon_bot_transfer_orange.svg')}
                  alt=""
                />
              </div>
              <p>Transferência de Bot</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'MenuAI',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_blocos_padrao--MenuAI"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_blocos_padrao--MenuAI"
              draggable
              onDragStart={(e) => handleDragStart(e, 'MenuAI')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({ dragging: draggingType === 'MenuAI' })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Menu de Opções"
                alt=""
              />
              <img
                className="no-drag"
                style={{ width: 32, height: 32 }}
                src={require('../../../../assets/images/icone-menu-ia.svg')}
                alt=""
              />
              <p>Menu IA</p>
            </label>
          </li>

        </ul>
      </ul>
      <ul
        className="creator-menu creator-menu-integracao"
        hidden={isBlocos !== 'integracao'}
      >
        <p className="sub-title-integracao">Integrações</p>
        <li
          className="header header-integracao"
          style={{ marginTop: 10 }}
          data-toggle="collapse"
          data-target="#integracao-vtex"
        >
          <span className="div-item-integracao">
            <img className="img-item-integracao" alt="" src={iconVtex} />
          </span>
          <span className="div-item-texto">vTex</span>
        </li>

        <ul className="collapse multi-collapse" id="integracao-vtex">
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexAddToCart',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-add-to-cart"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-add-to-cart"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexAddToCart')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexAddToCart',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Adicionar ao Carrinho"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_adicionar_ao_carrinho.png"
                alt=""
              />
              <p>Adicionar ao carrinho</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexUpdateCart',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-update-cart"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-update-cart"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexUpdateCart')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexUpdateCart',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Atualizar carrinho VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_atualizar_carrinho.png"
                alt=""
              />
              <p>Atualizar carrinho</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexRemoveFromCart',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-remove-from-cart"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-remove-from-cart"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexRemoveFromCart')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexRemoveFromCart',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Remover do carrinho VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_remover_item_carrinho.png"
                alt=""
              />
              <p>Remover item do carrinho</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexCatalogProducts',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-get-product-list"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-get-product-list"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexCatalogProducts')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexCatalogProducts',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="List produtos VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_listar_catalogo.png"
                alt=""
              />
              <p>Listar catálogo</p>
            </label>
          </li>
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexOrderList',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-oder-list"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-oder-list"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexOrderList')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexOrderList',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar pedido da VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_listar_carrinho.png"
                alt=""
              />
              <p>Listar carrinho</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexCatalogProduct',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-get-product"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-get-product"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexCatalogProduct')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexCatalogProduct',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Buscar produto do catalógo VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_buscar_produto_catalogo.png"
                alt=""
              />
              <p style={{ width: 77 }}>Buscar produto do catálogo</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexCartProduct',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--vtex-get-product-from-cart"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-get-product-from-cart"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexCartProduct')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexCartProduct',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Buscar produto do carrinho VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_buscar_produto_carrinho.png"
                alt=""
              />
              <p style={{ width: 77 }}>Buscar produto do carrinho</p>
            </label>
          </li>

          <li style={{ marginTop: 6 }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'VTexCheckout',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--vtex-checkout"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--vtex-checkout"
              draggable
              onDragStart={(e) => handleDragStart(e, 'VTexCheckout')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'VTexCheckout',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Checkout VTex"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_checkout.png"
                alt=""
              />
              <p style={{ width: 70 }}>Checkout</p>
            </label>
          </li>
        </ul>

        <li
          className="header header-integracao"
          style={{ marginTop: 10 }}
          data-toggle="collapse"
          data-target="#integracao-zendesk"
        >
          <span className="div-item-integracao">
            <img className="img-item-integracao" alt="" src={iconZendesk} />
          </span>
          <span className="div-item-texto">Zendesk</span>
        </li>

        <ul className="collapse multi-collapse" id="integracao-zendesk">
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskCreateRequest',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--zendesk-create-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-create-request"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskCreateRequest')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskCreateRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Criar Nova Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_create_request-1.svg"
                alt=""
              />
              <p>Novo Ticket</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskListRequests',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--zendesk-list-requests"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-list-requests"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskListRequests')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskListRequests',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar Tickets"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_list_request-1.svg"
                alt=""
              />
              <p>Listar Tickets</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskShowRequest',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--zendesk-show-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-show-request"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskShowRequest')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskShowRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Mostrar uma Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_show_request.svg"
                alt=""
              />
              <p>Checar Ticket</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskListComments',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--zendesk-list-comments"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-list-comments"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskListComments')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskListComments',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar comentários"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_list_comments.svg"
                alt=""
              />
              <p>Listar Comentários</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskInsertComment',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--zendesk-insert-comment"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-insert-comment"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskInsertComment')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskInsertComment',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Inserir novo Comentário"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_insert_comment-1.svg"
                alt=""
              />
              <p style={{ width: 77 }}>Inserir Comentário</p>
            </label>
          </li>

          <li style={{ marginTop: '5px' }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskAttachFile',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--zendesk-attach-file"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-attach-file"
              draggable
              onDragStart={(e) => handleDragStart(e, 'ZendeskAttachFile')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskAttachFile',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Anexar um arquivo"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_attach_file-1.svg"
                alt=""
              />
              <p style={{ width: 77 }}>Anexar Arquivo</p>
            </label>
          </li>

          <li style={{ marginTop: 18 }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'ZendeskUpdateStatusRequest',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--zendesk-update-status-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--zendesk-update-status-request"
              draggable
              onDragStart={(e) =>
                handleDragStart(e, 'ZendeskUpdateStatusRequest')
              }
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'ZendeskUpdateStatusRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Atualizar Status da Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_update_status.svg"
                alt=""
              />
              <p style={{ width: 70 }}>Finalizar Ticket</p>
            </label>
          </li>
        </ul>

        <li
          className="header header-integracao"
          style={{ marginTop: 10 }}
          data-toggle="collapse"
          data-target="#integracao-jira"
        >
          <span className="div-item-integracao">
            <img className="img-item-integracao" alt="" src={iconJira} />
          </span>
          <span className="div-item-texto">Jira</span>
        </li>

        <SubMenuJira
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
          draggingType={draggingType}
        />

        <li
          className="header header-integracao"
          style={{ marginTop: 10 }}
          data-toggle="collapse"
          data-target="#integracao-rd-station"
        >
          <span className="div-item-integracao">
            <img
              className="img-item-integracao"
              src={iconRDStation}
              alt="RD Station"
            />
          </span>
          <span className="div-item-texto">RD Station</span>
        </li>

        <SubMenuRDStation
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
          draggingType={draggingType}
        />

        <li
          className="header header-integracao"
          style={{ marginTop: 10 }}
          data-toggle="collapse"
          data-target="#integracao-glpi"
        >
          <span className="div-item-integracao">
            <img className="img-item-integracao" alt="" src={iconGlpi} />
          </span>
          <span className="div-item-texto">GLPi</span>
        </li>

        <ul className="collapse multi-collapse" id="integracao-glpi">
          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiCreateRequest',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--glpi-create-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-create-request"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiCreateRequest')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiCreateRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Criar Nova Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_create_request-1.svg"
                alt=""
              />
              <p>Novo Ticket</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiListRequests',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--glpi-list-requests"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-list-requests"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiListRequests')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiListRequests',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar Tickets"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_list_request-1.svg"
                alt=""
              />
              <p>Listar Tickets</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiShowRequest',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--glpi-show-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-show-request"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiShowRequest')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiShowRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Mostrar uma Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_show_request.svg"
                alt=""
              />
              <p>Checar Ticket</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiListComments',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--glpi-list-comments"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-list-comments"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiListComments')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiListComments',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar comentários"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_list_comments.svg"
                alt=""
              />
              <p>Listar Comentários</p>
            </label>
          </li>

          <li>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiInsertComment',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--glpi-insert-comment"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-insert-comment"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiInsertComment')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiInsertComment',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Inserir novo Comentário"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_insert_comment-1.svg"
                alt=""
              />
              <p style={{ width: 77 }}>Inserir Comentário</p>
            </label>
          </li>

          <li style={{ marginTop: '5px' }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiAttachFile',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--glpi-attach-file"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-attach-file"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiAttachFile')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiAttachFile',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Anexar um arquivo"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_attach_file-1.svg"
                alt=""
              />
              <p style={{ width: 77 }}>Anexar Arquivo</p>
            </label>
          </li>
          <li style={{ marginTop: '5px' }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiListGroups',
                'dragging-overlay': true,
              })}
            />
            <input
              id="radio_avancado--glpi-list-groups"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-list-groups"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiListGroups')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiListGroups',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Listar Grupos"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_list_comments.svg"
                alt=""
              />
              <p style={{ width: 77 }}>Listar Grupos</p>
            </label>
          </li>

          <li style={{ marginTop: 18 }}>
            <span
              className={classNames({
                'd-none': draggingType !== 'GlpiUpdateStatusRequest',
                'dragging-overlay': true,
              })}
              style={{ height: 82 }}
            />
            <input
              id="radio_avancado--glpi-update-status-request"
              type="radio"
              name="radio_blocos_padrao"
            />
            <label
              htmlFor="radio_avancado--glpi-update-status-request"
              draggable
              onDragStart={(e) => handleDragStart(e, 'GlpiUpdateStatusRequest')}
              onDragEnd={(e) => handleDragEnd(e)}
              className={classNames({
                dragging: draggingType === 'GlpiUpdateStatusRequest',
              })}
            >
              <img
                src="/assets/images/icons/icon_hint.svg"
                className="hint"
                data-toggle="tooltip"
                data-placement="right"
                title="Atualizar Status da Requisição"
                alt=""
              />
              <img
                className="no-drag"
                src="/assets/images/icons/builder/icon_update_status.svg"
                alt=""
              />
              <p style={{ width: 70 }}>Finalizar Ticket</p>
            </label>
          </li>
        </ul>
      </ul>
    </div>
  );
};

export default SubMenuChatItems;
